import { render, staticRenderFns } from "./FormPerVoucher.vue?vue&type=template&id=70f5e632"
import script from "./FormPerVoucher.vue?vue&type=script&lang=js"
export * from "./FormPerVoucher.vue?vue&type=script&lang=js"
import style0 from "./FormPerVoucher.vue?vue&type=style&index=0&id=70f5e632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports